import Styles from "./Globalstyles";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import BrowseRoutes from "./BrowseRoutes";

export function IsLoged() {
	const cookies = document.cookie.split("; ");
	for (const cookie of cookies) {
		const [key, value] = cookie.split("=");
		if (key === "isLoged") return value;
	}
	return null;
}
export function USER_ID() {
	const cookies = document.cookie.split("; ");
	for (const cookie of cookies) {
		const [key, value] = cookie.split("=");
		if (key === "userId") return value;
	}
	return null;
}

function App() {
	return (
		<>
			<Styles />
			<Router>
				<BrowseRoutes />
			</Router>
		</>
	);
}

export default App;
